export async function composeModAtlas({base, width, height, patches}, {makeCanvas, decode, encode, cancelled = () => false}) {
    const canvas = makeCanvas(width, height);
    const context = canvas.getContext('2d');
    context.drawImage(base, 0, 0, width, height);
    let changed = 0;
    // Decode only four sprites at a time, then release their pixel buffers.
    for (let offset = 0; offset < patches.length && !cancelled(); offset += 4) {
        const batch = patches.slice(offset, offset + 4);
        const images = await Promise.all(batch.map(async patch => {
            try { return patch.blob instanceof Blob ? await decode(patch.blob) : null; } catch { return null; }
        }));
        images.forEach((image, index) => {
            if (!image) return;
            if (!cancelled()) {
                const {x, y, w, h} = batch[index].frame;
                context.clearRect(x, y, w, h);
                context.drawImage(image, x, y, w, h);
                changed++;
            }
            image.close?.();
        });
        // The fallback also yields between batches on browsers without workers.
        if (typeof window !== 'undefined') await new Promise(resolve => setTimeout(resolve, 0));
    }
    return {canvas, changed, blob: changed && !cancelled() ? await encode(canvas) : null};
}
